"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BranchWebAppApiImpl = void 0;
const branch_1 = require("./v2/branch");
class BranchWebAppApiImpl {
    async getBranches(params) {
        return await (0, branch_1.fetchBranches)(params);
    }
}
exports.BranchWebAppApiImpl = BranchWebAppApiImpl;
